import React, { useState, useEffect, useRef } from "react";  import ReactHTMLTableToExcel from "react-html-table-to-excel";  import { Container, Row, Col, Table } from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import * as OFMSUI from "react-bootstrap"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import HousingService from "../../../Services/HousingService"; import { useReactToPrint } from "react-to-print"; import { FaFastBackward, FaPrint } from "react-icons/fa";
import { generatePDF, ModuleHeader } from "../../utils/commonFunctions";



const BankBalances = () => {
  const [bankBalance, setBankBalance] = useState([]);

  useEffect(() => {
    HousingService.BankBalancesReport().then((res) => {
      if (res.data) { setBankBalance(res.data); }
    }).catch((error) => { console.error("Error fetching bank balances:", error); });
  }, []);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current, documentTitle: "BankSubsidaryReport"
  });


  return (
    <div>
      <NavigationServicesHeader />
      <ModuleHeader title="BANK BALANCES REPORT" />

      <OFMSUI.Container className="outer-page-content-container fluid" fluid style={{ width: "90%" }}>
        <Row>
          <Col xs={12} className="mb-2 float-end">
            <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} >
              <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="BankSubsidary" sheet="tablexls" buttonText="Excel" />
            </button>
            <button className="btn btn-danger btn-sm" onClick={() => generatePDF("my-table", "BANK BALANCES REPORT", "BANKBALANCESREPORT.pdf", 8)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
            <button className="btn btn-warning btn-sm" onClick={handlePrint} style={{ float: "right", marginLeft: "3px" }} > Print <FaPrint /> </button>
          </Col>
        </Row>
        <div ref={componentRef} className="print-content">
          <Table striped bordered hover id="my-table">
            <thead className="fw-bold">
              <tr> <td colSpan={10} style={{ textAlign: "center" }}> Bank Balances Report </td> </tr>
              <tr className="table_countshead">
                <th>S No.</th> <th>Bank Name</th> <th>Branch Name</th> <th>Account No</th> <th>BankName & Account No.</th> <th>Opening Balance</th> <th>Current Balance</th> <th>Is it in Regular Use</th>
              </tr>
            </thead>
            <tbody>
              {bankBalance.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td> <td>{item.bankname}</td> <td>{item.branchname}</td> <td>{item.accountno}</td> <td>{item.banknameaccountno}</td> <td style={{ textAlign: "right" }}> {parseInt(item.balance).toFixed(2)} </td> <td style={{ textAlign: "right" }}>{item.current_balance}</td> <td style={{ textAlign: "center", verticalAlign: "middle" }}> <button className="btn btn-secondary" type="submit" style={{ fontSize: "12px" }} > {item.case} </button> </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </OFMSUI.Container>
    </div>
  );
};

export default BankBalances;
